<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Analytics</span>
      <h2 class="chart-title">Venda de Pedras por Mês</h2>
      <p class="chart-subtitle">Quantidade vendida em M² e chapas estimadas no período selecionado</p>
      <span class="chart-periodo">Período: {{ dataInicial }} a {{ dataFinal }}</span>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="carregarDados()" [disabled]="isLoading">
      Atualizar
    </button>
  </div>


<div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando dados...</span>
  </div>

  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span>Não foi possível carregar as vendas de pedras.</span>
    <button class="btn btn-primary btn-sm" type="button" (click)="carregarDados()">Tentar novamente</button>
  </div>

  <div *ngIf="!isLoading && !hasError" class="table-shell">
    <div class="table-summary">
      <span><strong>Total M² Vendido:</strong> {{ totalM2Vendido | number:'1.2-2' }}</span>
      <span><strong>Total Chapas Estimadas:</strong> {{ totalChapasEstimadas | number:'1.0-0' }}</span>
    </div>

    <div class="table-scroll">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light sticky-head">
          <tr>
            <th scope="col">Produto</th>
            <th scope="col">Tipo</th>
            <th scope="col" class="text-center">Referência</th>
            <th scope="col" class="text-end">M² Vendido</th>
            <th scope="col" class="text-end">Dim. Unit. (M²)</th>
            <th scope="col" class="text-end">Chapas Est.</th>
            <th scope="col" class="text-end">% Aproveit.</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dados">
            <td class="fw-medium">{{ item.nomeProduto }}</td>
            <td><span class="badge bg-secondary">{{ item.tipo }}</span></td>
            <td class="text-center">{{ item.mesReferencia }}</td>
            <td class="text-end">{{ item.qtdM2VendidoMes | number:'1.2-2' }}</td>
            <td class="text-end">{{ item.dimensaoUnitariaM2 | number:'1.2-2' }}</td>
            <td class="text-end fw-semibold text-primary">{{ item.chapasEstimadas | number:'1.0-0' }}</td>
            <td class="text-end">{{ item.pctAproveitamento | number:'1.0-2' }}%</td>
          </tr>
          <tr *ngIf="dados.length === 0">
            <td colspan="7" class="text-center text-muted py-4">Nenhuma venda encontrada para o período.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
